import React from 'react';
import './ServicePage.css';

const DASK = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>🌍 DASK (Zorunlu Deprem Sigortası)</h1>
          <p>Zorunlu deprem sigortası ile evinizi koruyun</p>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2>DASK Nedir?</h2>
            <p>
              DASK (Doğal Afet Sigortaları Kurumu), Türkiye'de konutlar için 
              zorunlu deprem sigortasıdır. Deprem sonucu oluşabilecek hasarları 
              karşılamak amacıyla yapılan bu sigorta, yasal bir zorunluluktur.
            </p>
          </section>

          <section className="service-section">
            <h2>Kapsamı</h2>
            <ul className="service-list">
              <li>Deprem nedeniyle oluşan hasarlar</li>
              <li>Deprem sonrası yangın ve patlama</li>
              <li>Deprem sonrası toprak kayması</li>
              <li>Yapısal hasarların karşılanması</li>
            </ul>
          </section>

          <section className="service-section">
            <h2>Avantajları</h2>
            <ul className="service-list">
              <li>Yasal zorunluluğu karşılar</li>
              <li>Deprem riskine karşı koruma</li>
              <li>Uygun fiyatlı sigorta çözümü</li>
              <li>Devlet garantili sigorta</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DASK;

